import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { AnimationService } from 'src/app/utils/animation.service';
import { Constants } from '../../utils/constants';
import { UtmService } from '../../utils/utm.service';

@Component({
  selector: 'app-career-information',
  templateUrl: './career-information.component.html',
  styleUrls: ['../home.component.scss', './career-information.component.scss']
})
export class CareerInformationComponent implements OnInit {
  formGenericUrl: string = Constants.formGenericUrl;
  googleDriveUrl: string = Constants.googleDriveUrl;
  faqRedirectUrl: string = Constants.faqRedirectUrl;

  @ViewChild('firstSection')
  firstSection: ElementRef;

  @ViewChild('secondSection')
  secondSection: ElementRef;

  constructor(private animation: AnimationService, private utmService: UtmService) { }

  ngOnInit(): void {
    this.formGenericUrl = this.utmService.getFormPath();
    const queryParams = this.utmService.getQueryParams();
    const { utm_source, utm_medium, utm_campaign } = queryParams;
    const params = `?utm_source=${utm_source}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}`;
    this.faqRedirectUrl += params;
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event) {
    this.animation.startRightToLeftAnimation(this.firstSection.nativeElement);
    this.animation.startRightToLeftAnimation(this.secondSection.nativeElement);
  }
}
